enum LeaveDuration {
  FULL_DAY = 'FullDay',
  THREE_QUARTERS_DAY = 'ThreeQuartersDay',
  HALF_DAY = 'HalfDay',
  QUARTER_DAY = 'QuarterDay',
  OTHER = 'Other',
}
export default LeaveDuration
